module.exports = __webpack_public_path__ + "static/img/gg.48a11e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/gg.png
// module id = pYkE
// module chunks = 1